<template>
  <h4>
    Detalhes da Aula:
    <span
      role="button"
      class="badge bg-warning"
      title="Editar"
      @click="$emit('editLesson')"
    >
      Editar
    </span>
  </h4>
  <p><strong>Título</strong>: {{ lesson.title }}</p>
  <p><strong>Descrição</strong>: {{ lesson.description }}</p>
  <p>
    <strong>Status</strong>:
    <span v-html="statusTranslate(lesson.status)" />
  </p>
  <p>
    <strong>Cadastrado por</strong>:
    {{ createdUpdatedUser(lesson.createdBy, lesson.createdAt) }}
  </p>
  <p>
    <strong>Atualizado por</strong>:
    {{ createdUpdatedUser(lesson.updatedBy, lesson.updatedAt) }}
  </p>
</template>

<script>
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'DetailLesson',

  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  emits: ['editLesson'],

  data() {
    return {
      createdUpdatedUser,
      statusTranslate,
    }
  },
}
</script>
